var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { fontSize, fontWeight, space, width } from 'styled-system';
import Text from '../Text';
export var StyledSeparator = styled.hr(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border: 0;\n  border-top: 1px solid ", ";\n  display: block;\n  height: 1px;\n  padding: 0;\n  ", ";\n"], ["\n  border: 0;\n  border-top: 1px solid ", ";\n  display: block;\n  height: 1px;\n  padding: 0;\n  ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.color.border;
}, space);
export var StyledLine = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background-color: ", ";\n  height: 1px;\n  ", ";\n"], ["\n  background-color: ", ";\n  height: 1px;\n  ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.color.background;
}, width);
export var SeparatorText = styled(Text)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: ", ";\n  font-weight: ", ";\n  margin: ", ";\n  white-space: nowrap;\n  ", "\n  ", "\n"], ["\n  color: ", ";\n  font-weight: ", ";\n  margin: ", ";\n  white-space: nowrap;\n  ", "\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.color.disabled;
}, function (_a) {
    var theme = _a.theme;
    return theme.fontWeights.regular;
}, function (_a) {
    var theme = _a.theme;
    return "0 " + theme.space[2] + "px";
}, fontWeight, fontSize);
export var SeparatorContainer = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  ", "\n  ", "\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  ", "\n  ", "\n"])), width, space);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
